import { render } from "./NewEmployeesEdit.vue?vue&type=template&id=1a81844b&scoped=true&ts=true"
import script from "./NewEmployeesEdit.vue?vue&type=script&lang=ts"
export * from "./NewEmployeesEdit.vue?vue&type=script&lang=ts"

import "./NewEmployeesEdit.vue?vue&type=style&index=0&id=1a81844b&lang=scss&scoped=true"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\Core.Services\\Core.WebApp\\admin-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a81844b"]])

export default __exports__